// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__MzG01","buttons":"SendReceipts_buttons__3OHSY","email":"SendReceipts_email__1Nusz","bookApptTitle":"SendReceipts_bookApptTitle__144IH"};